import EditProgramSchedule from "../../../../modules/academyPrograms/ui/programs/schedule/EditProgramSchedule";
import { WrapperModalUsers } from "./styled";
import { ProgramScheduleType } from "../../../../types/dto/program";

export const ModalEditProgramsSchedule = ({
  openModal,
  setOpenModal,
  programSchedule,
  onSuccess,
}: {
  openModal: boolean;
  setOpenModal: (value: boolean) => void;
  programSchedule?: ProgramScheduleType;
  onSuccess?: () => void;
}) => {
  return (
    <WrapperModalUsers
      title="Editar cronograma de pago"
      open={openModal}
      width={"320px"}
      destroyOnClose
      onClose={() => {
        setOpenModal(false);
      }}
    >
      {programSchedule ? (
        <EditProgramSchedule
          programSchedule={programSchedule}
          setOpenModal={setOpenModal}
          onSuccess={onSuccess}
        />
      ) : null}
    </WrapperModalUsers>
  );
};
